<div class="central-content">
    <div class="heading-image mb-30"></div>
    <div class="d-flex flex-column align-items-center mx-15 my-30">
      <div class="vo-heading-bold-24 mb-30" [innerHTML]="referenceDataLabels.SystemUnavailableHeader | localizeLabel"></div>
      <div class="vo-body-regular-14" [innerHTML]="referenceDataLabels.SystemUnavailableBody | localizeLabel"></div>
    </div>
  </div>